import React from "react";
import useTeacherCalendar from "./hook";
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar";
import Calendar from "@toast-ui/react-calendar";
import "tui-calendar/dist/tui-calendar.css";
import "tui-date-picker/dist/tui-date-picker.css";
import "tui-time-picker/dist/tui-time-picker.css";
import "../Availability/tui-calendar.css";
import moment from "moment";
import available_icon from "../../assets/img/availability-icon.png";
import not_available_icon from "../../assets/img/cross.png";
import { StylesTeacherCalendar } from "./styled";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import FormDatePicker from "../../Components/FormField/FormDatePicker";
import BookingModal from "./BookingModal";
import { notify } from "react-notify-toast";
import { getRulesFlag } from "../../Helper/BookingHelper";
import { connect } from "react-redux";

const TeacherCalendarPageLayout = ({
  calendarRef,
  handleRenderDate,
  getGridCategoryTemplate,
  handleClickPrevButton,
  handleClickNextButton,
  state,
  onViewChange,
  onHideWeekend,
  handleClickTodayButton,
  handlePickMonth,
  user,
  handleOpenBooking,
  isOpenBookingModal,
  handleCloseBooking,
  bookingStates,
  setBookingStates,
}) => {
  const isSelect = (time, date) => {
    let newdate = moment(date).format("MM-DD-YYYY");
    const userData = user;
    let flag = false;
    if (userData.rules) {
      if (userData.rules[0][newdate] && userData.rules[0][newdate].time) {
        flag = userData.rules[0][newdate].time.includes(time);
        return flag;
      }
    }
    return flag;
  };

  return (
    <div style={{ background: "#f5f5f5", paddingBottom: "24px" }}>
      {isOpenBookingModal && (
        <BookingModal
          bookingStates={bookingStates}
          teacher={user}
          handleCloseBooking={handleCloseBooking}
          isOpenBookingModal={isOpenBookingModal}
        />
      )}
      <SwitchMenuBar isViewAsPersonnel={true} isTeacherInfo={true} />
      <StylesTeacherCalendar>
        <div className="calendar-container">
          <div className="flex items-center user-profile">
            <img src={user?.img_url} alt="teacher_avatar" />
            <p>
              {user?.first_name} {user?.last_name}
            </p>
          </div>
          <div id="menu" className="calendar-menu ml-3">
            <span className="dropdown">
              <select
                className="btn btn-default btn-sm dropdown-toggle dropwn"
                onChange={onViewChange}
              >
                <option value="month">Monthly</option>
                <option value="2 weeks">2 weeks</option>
              </select>
            </span>
            <span id="menu-navi">
              <button
                type="button"
                className="btn btn-default btn-sm hideWeekend"
                data-action="move-today"
                onClick={onHideWeekend}
              >
                {state.toggleWeekend}
              </button>
              <button
                type="button"
                className="btn btn-default btn-sm move-today"
                data-action="move-today"
                onClick={handleClickTodayButton}
              >
                Today
              </button>
            </span>
            <span className="mt-3 ml-2 calendar-month-picker">
              <FormDatePicker
                onChange={(date) => handlePickMonth(date)}
                selectsEnd
                dateFormat="YYYY / MMMM"
                showMonthYearPicker
                value={moment(state.today, "DD-MM-YYYY").format("YYYY / MMMM")}
                maxWidth
              />
            </span>
          </div>
          <div className="calendar-info-icon">
            <div className="small-screen-disappear">
              <HoverIcon
                icon="info circle"
                color="grey"
                text="Click on any future date to set availability. To view your booking details, click on the Job List tab."
                size="huge"
                place="left"
              />
            </div>
            <div className="small-screen-appear">
              <HoverIcon
                icon="info circle"
                color="grey"
                text="Click on any future date to set availability. To view your booking details, navigate via dropdown to Job List."
                size="huge"
                place="left"
              />
            </div>
            <div className="mr-3 ml-1">
              <button
                type="button"
                className="btn btn-default btn-sm move-day mr-3"
                data-action="move-prev"
                onClick={handleClickPrevButton}
              >
                <i
                  className="fa fa-arrow-left text-white"
                  data-action="move-prev"
                />
              </button>
              <button
                type="button"
                className="btn btn-default btn-sm move-day"
                data-action="move-next"
                onClick={handleClickNextButton}
              >
                <i
                  className="fa fa-arrow-right text-white"
                  data-action="move-next"
                />
              </button>
            </div>
          </div>
          <Calendar
            height="740px"
            ref={calendarRef}
            taskView={true}
            today={true}
            schedules={state.schedules}
            alldayView={false}
            useCreationPopup={false}
            useDetailPopup={false}
            view={state.view}
            onBeforeCreateSchedule={(e) => {
              if (moment().subtract(1, "days").isBefore(e.start._date)) {
                handleOpenBooking(true);
                setBookingStates({
                  selected_date: e.start._date,
                  check_morning: isSelect("morning", e.start._date),
                  check_afternoon: isSelect("afternoon", e.start._date),
                  check_evening: isSelect("evening", e.start._date),
                  check_all: isSelect("all", e.start._date),
                });
              } else {
                notify.show("Please select today or a future date");
              }
            }}
            calendars={[
              {
                id: "1",
                bgColor: "#3bb4d8",
              },
            ]}
            template={{
              schedule: (schedule) => {
                return getGridCategoryTemplate(schedule.category);
              },

              allday: (schedule) => {
                return `<div class=${
                  schedule.calendarId == 1
                    ? "calendar-booking"
                    : "calendar-interview"
                }>
         <span class="calendar-booking-desktop">${schedule.title}</span>

         <span class="calendar-booking-mobile">JOB</span>
         </div>`;
              },

              time: (schedule) => {
                if (schedule.title === "Not Available") {
                  return `<div class="availability-entry">
               <img src="${not_available_icon}" class="not-available-icon"/>
               <span class="availability-span">${schedule.title}</span>
               </div>`;
                } else {
                  return `<div class="availability-entry">
               <img src="${available_icon}" class="availability-icon"/>
               <span class="availability-span">${schedule.title}</span>
               </div>`;
                }
              },
            }}
            onLoad={handleRenderDate}
            month={{
              workweek: state.isWorkWeek,
              startDayOfWeek: 0,
              visibleWeeksCount: state.visibleWeeksCount,
              isAlways6Week: false,
            }}
            week={{
              workweek: state.isWorkWeek,
            }}
          />
        </div>
      </StylesTeacherCalendar>
    </div>
  );
};

const TeacherCalendarPage = (props) => {
  return <TeacherCalendarPageLayout {...useTeacherCalendar(props)} />;
};

function mapStateToProps(state) {
  return {
    college: state.college_details,
  };
}

export default connect(mapStateToProps)(TeacherCalendarPage);
